import getEnv from '@/utils/env';

/** Keycloak account console URL for the realm used by the login URI. */
function accountUrlFromLoginUri(loginUri) {
    if (!loginUri) return '';
    try {
        const url = new URL(loginUri, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
        const match = url.pathname.match(/^(.*\/realms\/[^/]+)/);
        if (!match) return '';
        return `${url.origin}${match[1]}/account/`;
    } catch (e) {
        return '';
    }
}

export default {
    getUrl() {
        return getEnv('VUE_APP_QSC_ADMIN_UI_URL');
    },
    /**
     * Keycloak account console (profile, MFA). Explicit ACCOUNT_URI wins;
     * otherwise it is derived from the login URI so every environment works
     * without an extra variable.
     */
    getAccountUrl() {
        return getEnv('VUE_APP_QSC_ADMIN_UI_ACCOUNT_URI') || accountUrlFromLoginUri(getEnv('VUE_APP_QSC_ADMIN_UI_LOGIN_URI'));
    },
    /**
     * Base URL of the agent/chat API (agent-server). Falls back to the admin URL when unset,
     * which matches production where the ALB routes /api/v1/agent* to agent-server.
     */
    getChatUrl() {
        return getEnv('VUE_APP_QSC_ADMIN_UI_CHAT_URL') || this.getUrl();
    },
    getSearchUrl() {
        return getEnv('VUE_APP_QSC_ADMIN_UI_SEARCH_URL') || this.getUrl();
    },
    getVersion() {
        return getEnv('VUE_APP_QSC_ADMIN_UI_API_VERSION');
    }
}
